import wixAnimations from 'wix-animations';
import wixWindow from 'wix-window';

const SIDEBAR_MENU = {
    categories: {
        training: {
            button: '#training',
            buttonArrow: '#trainingArrow',
            submenu: '#trainingSubmenu',
        },
        videos: {
            button: '#videos',
            buttonArrow: '#videosArrow',
            submenu: '#videosSubmenu'
        }
    },
    openedPanels: {
        mainCategoryButton: '',
        mainCategoryArrow: '',
        mainCategoryDropdown: '',

        subCategoryButton: '',
        subCategoryArrow: '',
        subCategoryDropdown: '',
    },
    arrowsType: {
        open: `<svg preserveAspectRatio="xMidYMid meet" data-bbox="0.8 0 9.2 5.3" viewBox="0.8 0 9.2 5.3" xmlns="http://www.w3.org/2000/svg" data-type="color" role="img" aria-labelledby="svgcid-gny7s3arrcqy"><defs><style>#comp-kgh1vdf3_r_comp-kh9ms4x6 svg [data-color="1"] {fill: #FFFFFF;}</style></defs><title>Arrow down icon</title>
                    <g>
                        <path fill="#FFFFFF" d="M9.3 0L5.4 3.9 1.5 0 .8.7l4.6 4.6L10 .7 9.3 0z" data-color="1"></path>
                    </g>
                </svg>`,
        close: `<svg preserveAspectRatio="xMidYMid meet" data-bbox="0.8 0 9.2 5.3" viewBox="0.8 0 9.2 5.3" xmlns="http://www.w3.org/2000/svg" data-type="color" role="img" aria-labelledby="svgcid-gny7s3arrcqy"><defs><style>#comp-kgh1vdf3_r_comp-kh9ms4x6 svg [data-color="1"] {fill: #9A9A9A;}</style></defs><title>Arrow up icon</title>
                    <g>
                        <path fill="#9A9A9A" d="M9.3 0L5.4 3.9 1.5 0 .8.7l4.6 4.6L10 .7 9.3 0z" data-color="1"></path>
                    </g>
                </svg>`,
    }
}

export async function sidebar(mainCategory, categoryTitle) {
    await getWindowSize().then(winWidth => {
        if (winWidth < 1001) {
            activeSidebarForTabletMobile();
            $w('#verticalSidebar').hide();
        } else {
            $w('#verticalSidebar').show();
        }
    })
    return activateSidebarMenu(mainCategory, categoryTitle);
}

async function getWindowSize() {
    return wixWindow.getBoundingRect()
        .then((windowSizeInfo) => {
            return windowSizeInfo.window.width;
        });
}

//=====================
//      Sidebar
//=====================
// Tablet & Mobile only
function activeSidebarForTabletMobile() {
    activeMenuAndSearchTogglers();
}

function activeMenuAndSearchTogglers() {
    const sidebar = $w('#verticalSidebar');
    const sidebarToggle = $w('#toggleMenuTabletMobileOnly');
    const backdropColor = $w('#sidebarBackdropColorTabletMobileOnly');
    const sidebarWidth = 272;
    const sidebarTimeline = wixAnimations.timeline()
        .add(sidebar, { x: 0, duration: 300 })
        .add(backdropColor, { opacity: 1, duration: 175 });

    wixAnimations.timeline().add(sidebar, { x: -sidebarWidth, duration: 0 }).play();

    sidebarToggle.onClick(() => { sidebar.hidden ? sidebarTimeline.play() : sidebarTimeline.reverse(); });
    backdropColor.onClick(() => { sidebarTimeline.reverse(); });

    sidebarTimeline.onStart(() => {
        sidebar.expand();
        sidebar.show();
        backdropColor.expand();
    });

    sidebarTimeline.onReverseComplete(() => {
        sidebar.collapse();
        sidebar.hide();
        backdropColor.collapse();
    });
}

//=====================
//    Window Sizing
//=====================

function activateSidebarMenu(mainCategory, categoryTitle) {
    const sidebarButtons = SIDEBAR_MENU.categories;

    for (let i in sidebarButtons) {
        const category_btn = $w(sidebarButtons[i].button);
        const categoryArrow = $w(sidebarButtons[i].buttonArrow);
        const submenuBoxs = $w(sidebarButtons[i].submenu).children;

        category_btn.onClick(() => {
            toggleMainCategories(sidebarButtons[i].submenu, sidebarButtons[i].button, sidebarButtons[i].buttonArrow);
        });

        categoryArrow.onClick(() => {
            toggleMainCategories(sidebarButtons[i].submenu, sidebarButtons[i].button, sidebarButtons[i].buttonArrow);
        });

        for (let key in submenuBoxs) {
            if (Number(key) !== 0) { //Skip first button (All...)
                if (submenuBoxs[key].type === '$w.Button' || submenuBoxs[key].type === '$w.VectorImage') {
                    submenuBoxs[key].onClick(() => {
                        console.log('click')
                        if (submenuBoxs[key].type === '$w.Button')
                            toggleSubCategories('#' + submenuBoxs[Number(key) + 2].id, '#' + submenuBoxs[key].id, '#' + submenuBoxs[Number(key) + 1].id);
                        if (submenuBoxs[key].type === '$w.VectorImage')
                            toggleSubCategories('#' + submenuBoxs[Number(key) + 1].id, '#' + submenuBoxs[Number(key) - 1].id, '#' + submenuBoxs[key].id);
                    });
                }
            }
        }
    }

    if (mainCategory)
        openRelevantTab(mainCategory, categoryTitle);
}

function openRelevantTab(mainCategory, categoryTitle) {
    const category = SIDEBAR_MENU.categories[mainCategory];
    const submenuBoxs = $w(category.submenu).children;

    $w(category.button).style.backgroundColor = '#212121';
    wixAnimations.timeline().add($w(category.buttonArrow), { rotate: 180, duration: 0 }).play();
    $w(category.submenu).expand();

    if (categoryTitle) {
        for (let key in submenuBoxs) {
            if ((submenuBoxs[key].type === '$w.Button') && (submenuBoxs[key].label === categoryTitle)) {
                submenuBoxs[Number(key)].style.color = '#FFFFFF';
                submenuBoxs[Number(key) + 2].expand();
                wixAnimations.timeline().add(submenuBoxs[Number(key) + 1], { rotate: 180, duration: 0 }).play();
                submenuBoxs[Number(key) + 1].src = `<svg preserveAspectRatio="xMidYMid meet" data-bbox="0.8 0 9.2 5.3" viewBox="0.8 0 9.2 5.3" xmlns="http://www.w3.org/2000/svg" data-type="color" role="img" aria-labelledby="svgcid-gny7s3arrcqy"><defs><style>#comp-kgh1vdf3_r_comp-kh9ms4x6 svg [data-color="1"] {fill: #FFFFFF;}</style></defs><title>Arrow up icon</title>
                                                    <g><path fill="#FFFFFF" d="M9.3 0L5.4 3.9 1.5 0 .8.7l4.6 4.6L10 .7 9.3 0z" data-color="1"></path></g>
                                                </svg>`;

            }
            setTimeout(() => {
                for (let key in submenuBoxs) {
                    if (submenuBoxs[key].type === '$w.Box' && !submenuBoxs[key].collapsed) {
                        const subCategoryDropdown = '#' + submenuBoxs[key].id;
                        const subCategoryButton = '#' + submenuBoxs[Number(key) - 2].id;
                        const subCategoryArrow = '#' + submenuBoxs[Number(key) - 1].id;
                        markSubCategoryOpenedPanels(subCategoryDropdown, subCategoryButton, subCategoryArrow);
                    }
                }
            }, 1000)
        }
    }
    markMainCategoryOpenedPanels(category.submenu, category.button, category.buttonArrow)

}

function markMainCategoryOpenedPanels(submenu, mainCategoryButton, mainCategoryArrow) {
    SIDEBAR_MENU.openedPanels.mainCategoryDropdown = submenu;
    SIDEBAR_MENU.openedPanels.mainCategoryButton = mainCategoryButton;
    SIDEBAR_MENU.openedPanels.mainCategoryArrow = mainCategoryArrow;
}

function markSubCategoryOpenedPanels(subCategoryDropdown, subCategoryButton, subCategoryArrow) {
    SIDEBAR_MENU.openedPanels.subCategoryDropdown = subCategoryDropdown;
    SIDEBAR_MENU.openedPanels.subCategoryButton = subCategoryButton;
    SIDEBAR_MENU.openedPanels.subCategoryArrow = subCategoryArrow;
}

function toggleMainCategories(submenuId, buttonId, arrowId) {
    const submenu = $w(submenuId);

    if (submenu.collapsed) {
        closeOpenedPanels();
        SIDEBAR_MENU.openedPanels.mainCategoryDropdown = submenuId;
        SIDEBAR_MENU.openedPanels.mainCategoryButton = buttonId;
        SIDEBAR_MENU.openedPanels.mainCategoryArrow = arrowId;
        openMainCategory();
    } else {
        closeOpenedPanels();
    }
}

// Main Categories //
function openMainCategory() {
    if (SIDEBAR_MENU.openedPanels.mainCategoryDropdown !== '') {
        $w(SIDEBAR_MENU.openedPanels.mainCategoryDropdown).expand();
        $w(SIDEBAR_MENU.openedPanels.mainCategoryButton).style.backgroundColor = '#212121';
        wixAnimations.timeline().add($w(SIDEBAR_MENU.openedPanels.mainCategoryArrow), { rotate: 180, duration: 200 }).play();

    }
}

function closeOpenedPanels() {
    if (SIDEBAR_MENU.openedPanels.mainCategoryDropdown !== '') {
        $w(SIDEBAR_MENU.openedPanels.mainCategoryDropdown).collapse();
        $w(SIDEBAR_MENU.openedPanels.mainCategoryButton).style.backgroundColor = '#000000';
        wixAnimations.timeline().add($w(SIDEBAR_MENU.openedPanels.mainCategoryArrow), { rotate: 0, duration: 200 }).play();

    }
}

// Submenu Dropdown //
function toggleSubCategories(dropdownMenuId, buttonId, arrowId) {
    const dropdownMenu = $w(dropdownMenuId);

    if (dropdownMenu.collapsed) {
        closeSubmenuOpenedPanels();
        SIDEBAR_MENU.openedPanels.subCategoryDropdown = dropdownMenuId;
        SIDEBAR_MENU.openedPanels.subCategoryButton = buttonId;
        SIDEBAR_MENU.openedPanels.subCategoryArrow = arrowId;
        openSubCategory();
    } else {
        closeSubmenuOpenedPanels();
    }
}

function openSubCategory() {
    if (SIDEBAR_MENU.openedPanels.subCategoryDropdown !== '') {
        $w(SIDEBAR_MENU.openedPanels.subCategoryDropdown).expand();
        $w(SIDEBAR_MENU.openedPanels.subCategoryButton).style.color = '#FFFFFF';
        wixAnimations.timeline().add($w(SIDEBAR_MENU.openedPanels.subCategoryArrow), { rotate: 180, duration: 200 }).play();
        $w(SIDEBAR_MENU.openedPanels.subCategoryArrow).src = SIDEBAR_MENU.arrowsType.open;
    }
}

function closeSubmenuOpenedPanels() {
    if (SIDEBAR_MENU.openedPanels.subCategoryDropdown !== '') {
        $w(SIDEBAR_MENU.openedPanels.subCategoryDropdown).collapse();
        $w(SIDEBAR_MENU.openedPanels.subCategoryButton).style.color = '#9F9F9F';
        wixAnimations.timeline().add($w(SIDEBAR_MENU.openedPanels.subCategoryArrow), { rotate: 0, duration: 200 }).play();
        $w(SIDEBAR_MENU.openedPanels.subCategoryArrow).src = SIDEBAR_MENU.arrowsType.close;

    }
}